import React from 'react'

import cn from '../../libs/class-names'

export interface Props {
  classNames?: string[]
  title: React.ReactNode
  date: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  icon: React.ReactNode
  align?: 'left' | 'right'
  appearance?: 'default' | 'event' | 'eventResolved'
  unread?: boolean
}

const MessageListItem = ({
  classNames,
  title,
  date,
  children,
  footer,
  icon,
  align = 'left',
  appearance = 'default',
  unread = false,
}: Props) => (
  <div
    className={cn(
      'MessageListItem',
      {[`align-${align}`]: true, [`appearance-${appearance}`]: true, unread},
      classNames
    )}
  >
    <div className="MessageListItem__avatar">
      <div className="MessageListItem__icon">{icon}</div>
    </div>
    <div className="MessageListItem__content">
      <div className="MessageListItem__headline">
        <div className="MessageListItem__title">
          {title}
          {unread && <div className="MessageListItem__unread" />}
        </div>
        <div className="MessageListItem__date">{date}</div>
      </div>
      <div className="MessageListItem__message">
        {children}
        {footer && <div className="MessageListItem__footer">{footer}</div>}
      </div>
    </div>
  </div>
)

export default MessageListItem
